(async function() {
  function createPromise() {
    const promise = new Promise((resolve, reject) => {
        this.temp_resolve = resolve;
        this.temp_reject = reject;
    });
    promise.resolve = this.temp_resolve;
    promise.reject = this.temp_reject;
    delete this.temp_resolve;
    delete this.temp_reject;
    return promise;
  }

  async function get(url) {
    let res = await fetch(url);
    return res.json();
  }

  let livePromise = createPromise();
  let _isLive = false;
  async function poll() {
    if (location.search.includes('debugLivestream')) return livePromise.resolve();
    let {isLive} = await get('https://explore.auravinyl.com/livestream/status');
    if (!isLive) {
        if (_isLive) {
            hide();
            _isLive = false;
            return;
        }
    } else {
        _isLive = true;
        livePromise.resolve(true);
    }
    setTimeout(poll, 2000);
  }
  poll();

  await livePromise;
  
  const css = `
    @keyframes livestream-dot-blink {
        0%, 50% {
            opacity: 1;
            transform: scale(1);
        }
        51%, 100% {
            opacity: 0.3;
            transform: scale(0.8);
        }
    }

    .livestream-wrapper {
        position: fixed;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 120px !important;
        height: 95px !important;
        background: linear-gradient(0deg, rgba(39, 38, 50, 0.9) -21.93%, rgba(39, 38, 50, 0.85) 163.16%) !important;
        border-radius: 12px !important;
        padding: 4px !important;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3) !important;
        cursor: pointer !important;
        transition: all 0.3s ease !important;
        border: 2px solid transparent !important;
        box-sizing: border-box !important;
        z-index: 98 !important;
        bottom: 210px !important;
        right: 30px !important;
    }
    
    .livestream-wrapper:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4) !important;
        border-color: rgba(255, 255, 255, 0.1) !important;
    }
    
    .livestream-indicator {
        position: relative !important;
        display: flex !important;
        align-items: center !important;
        gap: 6px !important;
        margin-bottom: 3px !important;
    }
    
    .livestream-red-dot {
        position: relative !important;
        width: 8px !important;
        height: 8px !important;
        background: #ff4444 !important;
        border-radius: 50% !important;
        animation: livestream-dot-blink 1.5s infinite !important;
        box-shadow: 0 0 8px rgba(255, 68, 68, 0.6) !important;
        display: block !important;
        flex-shrink: 0 !important;
    }
    
    .livestream-text {
        position: relative !important;
        color: #ffffff !important;
        font-family: 'Inter', sans-serif !important;
        font-weight: bold !important;
        font-size: 12px !important;
        letter-spacing: 1px !important;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    
    .livestream-thumbnail-container {
        position: relative !important;
        border-radius: 6px !important;
        overflow: hidden !important;
        border: 2px solid rgba(255, 255, 255, 0.1) !important;
        transition: border-color 0.3s ease !important;
    }
    
    .livestream-wrapper:hover .livestream-thumbnail-container {
        border-color: rgba(255, 68, 68, 0.5) !important;
    }
    
    .livestream-thumbnail {
        position: relative !important;
        width: 100px !important;
        height: auto !important;
        display: block !important;
        transition: transform 0.3s ease !important;
    }
    
    .livestream-wrapper:hover .livestream-thumbnail {
        transform: scale(1.05) !important;
    }

    /* Responsive styling to match MeerkatOpen positioning */
    @media screen and (max-width: 600px) {
        .livestream-wrapper {
            width: 84px !important;
            height: 66px !important;
            bottom: 160px !important;
            right: 20px !important;
        }
        
        .livestream-thumbnail {
            width: 70px !important;
        }
        
        .livestream-text {
            font-size: 10px !important;
        }
        
        .livestream-red-dot {
            width: 5px !important;
            height: 5px !important;
        }
        
        .livestream-indicator {
            gap: 4px !important;
            margin-bottom: 2px !important;
        }
    }
  `;

  const html = `
    <div id="livestream-button" class="livestream-wrapper" style="display: none;">
        <div class="livestream-indicator">
            <div class="livestream-red-dot"></div>
            <span class="livestream-text">LIVE</span>
        </div>
        <div class="livestream-thumbnail-container">
            <img src="https://image.mux.com/pnWXD9l2WNTrGE3H2pqu02fccl02f8mTd6P34WyY9Xv024/animated.gif?width=120&time=${Date.now()}" 
                 alt="Live stream thumbnail" 
                 class="livestream-thumbnail" />
        </div>
    </div>
  `;

  // Inject CSS
  var style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  document.head.appendChild(style);

  // Inject HTML
  var newDiv = document.createElement('div');
  newDiv.innerHTML = html;
  document.body.appendChild(newDiv);

  // Get elements
  const livestreamButton = document.querySelector('#livestream-button');
  
  // Show the button
  livestreamButton.style.display = 'flex';

  // Add click handler
  livestreamButton.onclick = function() {    
    // Open your livestream modal/page here
    openLivestream();
  };

  function hide() {
    if (_iframe) _iframe.fnHide();
    livestreamButton.style.display = 'none';
  }

  var _iframe;
  function openLivestream() {
  console.log('Opening livestream...');
  
  // Create background overlay
  const overlay = document.createElement('div');
  overlay.id = 'livestream-overlay';
  overlay.style.cssText = `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background: rgba(0, 0, 0, 0.9) !important;
    z-index: 9998 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  `;
  
  // Create iframe
  let iframe = document.createElement('iframe');
  iframe.src = 'https://explore.auravinyl.com/?livestream';
  iframe.id = 'livestream-iframe';
  iframe.setAttribute('allow', 'autoplay; fullscreen; microphone; camera; encrypted-media');
  iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox');
  iframe.setAttribute('allowfullscreen', '');
  
  // Calculate responsive size based on the logic from Livestream.js
  function calculateIframeSize() {
    const stageWidth = window.innerWidth;
    const stageHeight = window.innerHeight;
    const aspectRatio = stageWidth / stageHeight;
    const isPortrait = aspectRatio < 1;
    const isTablet = aspectRatio >= 1 && aspectRatio < 1.5;
    
    let width, height;
    
    if (isPortrait) {
      // Mobile/portrait layout - prioritize video with adequate chat space
      const maxWidth = stageWidth * 0.95;
      const maxHeight = stageHeight * 0.9;
      
      // Calculate video height based on 16:9 aspect ratio
      const videoHeight = (maxWidth / 16) * 9;
      const chatMinHeight = 280; // Minimum space for chat functionality
      
      // Ensure we have enough space for both video and chat
      if (videoHeight + chatMinHeight <= maxHeight) {
        width = maxWidth;
        height = videoHeight + chatMinHeight;
      } else {
        // Reduce video size to accommodate chat
        const availableVideoHeight = maxHeight - chatMinHeight;
        const adjustedWidth = (availableVideoHeight / 9) * 16;
        width = Math.min(adjustedWidth, maxWidth);
        height = maxHeight;
      }
    } else if (isTablet) {
      // Tablet layout - balanced approach
      const maxWidth = stageWidth * 0.85;
      const maxHeight = stageHeight * 0.85;
      
      // Aim for 60% video, 40% chat
      const videoHeight = maxHeight * 0.6;
      const videoWidth = (videoHeight / 9) * 16;
      
      if (videoWidth <= maxWidth) {
        width = videoWidth;
        height = maxHeight;
      } else {
        // Width constrained - adjust proportionally
        const adjustedVideoHeight = (maxWidth / 16) * 9;
        const totalHeight = adjustedVideoHeight / 0.6; // Maintain 60/40 ratio
        width = maxWidth;
        height = Math.min(totalHeight, maxHeight);
      }
    } else {
      // Desktop layout - optimize for larger screens
      const maxWidth = Math.min(stageWidth * 0.75, 1200); // Cap at reasonable size
      const maxHeight = stageHeight * 0.85;
      
      // For desktop, aim for 70% video, 30% chat for better viewing
      const videoHeight = maxHeight * 0.7;
      const videoWidth = (videoHeight / 9) * 16;
      
      if (videoWidth <= maxWidth) {
        width = videoWidth;
        height = maxHeight;
      } else {
        // Width constrained
        const adjustedVideoHeight = (maxWidth / 16) * 9;
        const totalHeight = adjustedVideoHeight / 0.7; // Maintain 70/30 ratio
        width = maxWidth;
        height = Math.min(totalHeight, maxHeight);
      }
    }
    
    return { width, height };
  }
  
  // Get initial size
  const { width, height } = calculateIframeSize();
  
  // Style the iframe with calculated dimensions
  iframe.style.cssText = `
    width: ${width}px !important;
    height: ${height}px !important;
    border: none !important;
    z-index: 9999 !important;
    background: #000 !important;
  `;
  
  // Add iframe to overlay
  overlay.appendChild(iframe);
  
  // Add overlay to body
  document.body.appendChild(overlay);
  
  // Handle window resize to recalculate iframe size
  function handleResize() {
    const { width: newWidth, height: newHeight } = calculateIframeSize();
    iframe.style.width = `${newWidth}px`;
    iframe.style.height = `${newHeight}px`;
  }
  
  window.addEventListener('resize', handleResize);
  
  // Listen for messages from the iframe to close it
  function handleMessage(event) {
    if (event.data === 'closeLivestream' || event.data.type === 'closeLivestream') {
      closeLivestream();
    }
  }
  
  // Add event listener
  window.addEventListener('message', handleMessage);
  
  // Function to close the livestream
  function closeLivestream() {
    // Remove the overlay (which contains the iframe)
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }

    _iframe = null;
    
    // Remove event listeners
    window.removeEventListener('message', handleMessage);
    window.removeEventListener('resize', handleResize);
    
    // Show the livestream button again
    const livestreamButton = document.querySelector('#livestream-button');
    if (livestreamButton) {
      livestreamButton.style.display = 'flex';
      livestreamButton.style.visibility = 'visible';
      livestreamButton.classList.remove('hidden');
    }

    document.removeEventListener('keydown', handleKeydown);
    
    console.log('Livestream closed');
  }

      iframe.fnHide = closeLivestream;
    _iframe = iframe;
  
  // Optional: Close on Escape key
  function handleKeydown(event) {
    if (event.key === 'Escape') {
      closeLivestream();
    }
  }
  document.addEventListener('keydown', handleKeydown);
  
  // Optional: Close when clicking on the background overlay (not the iframe)
  overlay.onclick = function(event) {
    if (event.target === overlay) {
      closeLivestream();
    }
  };
}
})();